import { CdfFallbackSceneConfig } from './CdfFallbackScene'
import { ContainmentDomeSceneConfig } from './ContainmentDomeScene'
import { HorizontalTankSceneConfig } from './HorizontalTankScene'
import { LegacyBoilerSceneConfig } from './LegacyBoilerScene'
import { MissileSiloSceneConfig } from './MissileSiloScene'
import { MultiComponentSceneConfig } from './MultiComponentScene'
import { PipingSceneConfig } from './PipingScene'
import { PressureVesselSceneConfig } from './PressureVesselScene'
import { SceneFactoryConfig } from './sceneFactory'
import { ShipHullSceneConfig } from './ShipHullScene'
import { ShipSceneConfig } from './ShipScene'
import { VerticalTankSceneConfig } from './VerticalTankScene'

export const defaultSceneFactories: SceneFactoryConfig[] = [
  MultiComponentSceneConfig,
  VerticalTankSceneConfig,
  HorizontalTankSceneConfig,
  PipingSceneConfig,
  LegacyBoilerSceneConfig,
  ShipHullSceneConfig,
  ShipSceneConfig,
  MissileSiloSceneConfig,
  ContainmentDomeSceneConfig,
  PressureVesselSceneConfig,
  CdfFallbackSceneConfig,
]
